var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-phone"},[_c('p',{staticClass:"m-phone-title ellipsis"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"m-phone-content"},[_c('div',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }